module.exports = __webpack_public_path__ + "img/zs.ea4b2f3a.svg";